const formulaQueryKeys = {
  all: [{ scope: 'formulas' }] as const,
  lists: () => [{ ...formulaQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: { companyId?: string | null }) => [{ ...formulaQueryKeys.lists()[0], ...context }] as const
}

export default formulaQueryKeys
